import HeroSection from "./components/HeroSection";
import CategoryNav from "./components/CategoryNav";
import VideoGrid from "./components/VideoGrid";
import TrendingSidebar from "./components/TrendingSidebar";
import { mockVideos } from "@/mocks/videos";

export default function Home() {
  const featuredVideos = mockVideos.filter((v) => v.featured);
  const latestVideos = [...mockVideos].sort((a, b) => new Date(b.date).getTime() - new Date(a.date).getTime());
  const entertainmentVideos = mockVideos.filter((v) => v.category === "entertainment");

  return (
    <main>
      <HeroSection />
      <CategoryNav />
      <TrendingSidebar />
      <VideoGrid
        title="最新视频"
        subtitle="每日更新，不错过任何精彩"
        videos={latestVideos}
        linkTo="/category/hot"
      />
      <VideoGrid
        title="娱乐圈"
        subtitle="明星动态一网打尽"
        videos={entertainmentVideos}
        linkTo="/category/entertainment"
      />
    </main>
  );
}